import React from 'react';
import {NoteTitleView} from './Note.styles';
import {TextProps} from '../Text';

export const NoteTitle = ({children}: TextProps) => (
  <NoteTitleView colorVariant="primary" font="heading">
    {children}
  </NoteTitleView>
);
